
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[param]",
      function () {
        return require("private-next-pages/[param]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[param]"])
      });
    }
  